import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { ConfigProvider, message, Spin } from 'antd';
import enGB from 'antd/es/locale/en_GB';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import theme from 'shared/constants/theme.json';

const antTheme = {
  token: {
    fontSize: 16,
    fontFamily: theme['font-family'],
    colorPrimary: theme['primary-color'],
    colorLink: theme['link-color'],
    colorLinkHover: theme['link-color'],
    colorSuccess: theme['success-color'],
    colorWarning: theme['warning-color'],
    colorError: theme['error-color'],
    colorTextBase: theme['text-color'],
    colorTextDescription: theme['text-color-secondary'],
    colorTextPlaceholder: theme['text-color-secondary'],
    colorTextQuaternary: theme['border-color-base'],
    colorTextDisabled: theme['text-color-secondary'],
    colorIconBase: theme['text-color-secondary'],
    colorBgLayout: theme['layout-body-background'],
    colorBorder: theme['border-color-base'],
    colorBorderSecondary: theme['border-color-base'],
    controlItemBgActive: theme['border-color-base'],
    borderRadius: 8,
  },
  components: {
    Menu: {
      activeBarHeight: 0,
      lineWidth: 0,
    },
  },
};

// + 8 is just some extra padding from the top.
message.config({ top: (parseInt(theme.headerHeight, 10) + 8) });

Spin.setDefaultIndicator(<LoadingOutlined />);

dayjs.locale('en-gb');

const ExtellioConfigProvider = ({ children }) => (
  <ConfigProvider
    locale={enGB}
    theme={antTheme}
    getPopupContainer={() => document.getElementById('root')}
    popupMatchSelectWidth={false}
    form={{ requiredMark: false }}
  >
    {children}
  </ConfigProvider>
);

export default ExtellioConfigProvider;
